<template>
	<PureImageGridShell
		variant="mosaic"
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import PureImageGridShell from '../shared/PureImageGridShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageMosaic',
		components: { PureImageGridShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
